module.exports = "/_next/static/images/konfhubBluelogo-3a15ba59ad4eb4998528d3900852260d.png";